// Buceo
import DiveAdminAccount from "./views/DiveAdminAccount";
import DiveUserAccount from "./views/DiveUserAccount";
import HomePage from "./views/HomePage";

// Buceo
import EventForm from "./views/EventForm";
import EventSearchMap from "./views/EventSearchMap";
import EventBookList from "./views/EventBookList";
import EventDetail from "./views/EventDetail";
import EventEdit from "./views/EventEdit";

import PractitionerMaintainer from "./views/PractitionerMaintainer";
import PractitionerMaintainerItem from "./views/PractitionerMaintainerItem";

// Mantenedor de especies
import OrganismMaintainerList from "./views/OrganismMaintainerList";
import OrganismMaintainerItem from "./views/OrganismMaintainerItem";

//Biblioteca
import LibraryList from "./views/LibraryList";
import LibraryItem from "./views/LibraryItem";

const routerAppDive = [
  // Costa Pez
  {
    path: "/costa-pez/home",
    name: "Home",
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/buscador",
    name: "Buscador",
    component: EventSearchMap,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/nuevo",
    name: "Nuevo registro",
    component: EventForm,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/administrador/mi-cuenta",
    name: "Cuenta Administrador",
    component: DiveAdminAccount,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/administrador/usuarios",
    name: "Usuarios",
    component: PractitionerMaintainer,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/administrador/usuarios/:id",
    name: "Perfil usuario",
    component: PractitionerMaintainerItem,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/administrador/especies",
    name: "Mantenedor especies",
    component: OrganismMaintainerList,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/administrador/especies/:id",
    name: "Detalle especie",
    component: OrganismMaintainerItem,
    meta: { requiresAuth: true }
  },

  {
    path: "/costa-pez/usuario/mi-cuenta",
    name: "Mi Cuenta",
    component: DiveUserAccount,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/mis-buceos",
    name: "Mis buceos",
    component: EventBookList,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/buceos/:id",
    name: "Detalle buceo",
    component: EventDetail,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/buceos/:id/editar",
    name: "Editar buceo",
    component: EventEdit,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/biblioteca",
    name: "Biblioteca",
    component: LibraryList,
    meta: { requiresAuth: true }
  },
  {
    path: "/costa-pez/biblioteca/:id",
    name: "Detalle Especie",
    component: LibraryItem,
    meta: { requiresAuth: true }
  }
  // Fin Costa Pez
];

export default routerAppDive;
